import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './index.module.css'

type Props = { className?: string; tableClassName?: string; children: ReactNode }

export const TableLarge = (props: Props) => {
  const className = classNames(styles.wrap, props.className)

  return (
    <div className={className}>
      <table className={props.tableClassName}>{props.children}</table>
    </div>
  )
}
